import { useEffect, useState } from "react";
import { data, servicesColumns } from "../../../constants/serviceSettings";
import TableCard from "./tableCard";
import CustomPopupForm from "../../../component/customPopupModel";
import axiosInstance from "../../../configuration/request";
import BasicCustomTable from "../../../component/basicTable";

const DIALOG_TYPES = {
  CREATE: "service-settings",
  DELETE: "delete",
};

const initialTableData = [
  {
    title: "Wash & Fold (Category)",
    label: "wash_fold",
    rows: [],
    dataArray: [],
  },
  {
    title: "Tailoring,Ironing,Dry Cleaning (Gender)",
    label: "cloth_category",
    rows: [],
    dataArray: [],
  },
  {
    title: "Cloth Name",
    label: "cloth_name",
    rows: [],
    dataArray: [],
  },
  {
    title: "Tailoring Type",
    label: "tailoring_type",
    rows: [],
    dataArray: [],
  },
];

export default function ServiceSetting() {
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedTable, setSelectedTable] = useState("");
  const [deleteMessage, setDeleteMessage] = useState("");
  const [tableData, setTableData] = useState(initialTableData);
  const [viewAllTable, setViewAllTable] = useState(null);


  useEffect(() => {
    fetchTableData();
  }, []);

  const fetchTableData = async () => {
    try {
      const results = await Promise.all(
        initialTableData.map((section) => fetchSingleTableData(section.label))
      );
    } catch (err) {
      console.error("Failed to fetch table data:", err);
    }
  };

  const fetchSingleTableData = async (label) => {
    try {
      const res = await axiosInstance.get(`/customer/core/dropdown/${label}`);
      const updatedSection = {
        dataArray: res.data?.value,
        rows:
          res.data?.value?.map((item, index) => ({
            id: index + 1,
            name: item || "",
          })) || [],
      };
  
      setTableData((prevData) =>
        prevData.map((section) =>
          section.label === label ? { ...section, ...updatedSection } : section
        )
      );
      if (viewAllTable) {
        setViewAllTable({
          ...viewAllTable,
          dataArray: updatedSection.dataArray,
          rows: updatedSection.rows,
        });
      }
    } catch (error) {
      console.error(`Failed to fetch data for ${label}:`, error);
    }
  };

  const handleAdd = (label) => {
    setSelectedTable(label);
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleDelete = (row, label) => {
    setSelectedTable(label);
    setSelectedRow(row);
    setDeleteMessage(
      <>
        Are you sure you want to delete <b>{row.name}</b>?
      </>
    );
    setDialogType(DIALOG_TYPES.DELETE);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogType("");
    setSelectedRow(null);
    setSelectedTable("");
    setDeleteMessage("");
  };

  const updateDropdownValues = async (newValues) => {
    const payload = {
      key: selectedTable,
      values: newValues,
    };
    try {
      await axiosInstance.post(`/customer/core/dropdown`, payload);
      handleCloseDialog();
      await fetchSingleTableData(selectedTable);
    } catch (error) {
      console.error("Failed to update dropdown values:", error);
    }
  };
  const handleEdit = (row, label) => {
  setSelectedTable(label);
  setSelectedRow(row);
  setDialogType(DIALOG_TYPES.CREATE);  
  setOpenDialog(true);
};


  const handleSubmit = async (dropdownVal) => {
    if (!selectedTable) return;
    const selectedSection = tableData.find(
      (section) => section.label === selectedTable
    );
    const updatedDropdownVal = [
      ...(selectedSection?.dataArray || []),
      ...dropdownVal,
    ];
    await updateDropdownValues(updatedDropdownVal);
  };

  const handleDeleteConfirm = async (row) => {
    if (!selectedTable) return;
    const selectedSection = tableData.find(
      (section) => section.label === selectedTable
    );
    const updatedDropdownVal = (selectedSection?.dataArray || []).filter(
      (item) => item !== row.name
    );
    await updateDropdownValues(updatedDropdownVal);
  };

  return (
    <div className="pl-6 pr-4">
      <h2 className="text-2xl font-semibold mb-3 ml-3">
        Service Settings
      </h2>
      <div className="px-2 pb-4 h-[calc(100vh-140px)] overflow-y-auto hide-scrollbar">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {tableData.map((section) => (
           <TableCard
  key={section.title}
  title={section.title}
  label={section.label}
  rows={section.rows}
  columns={servicesColumns}
  onAdd={() => handleAdd(section.label)}
  onDelete={(row) => handleDelete(row, section.label)}
  onEdit={(row) => handleEdit(row, section.label)}   // 🔥 EDIT ENABLED
  onViewAll={() => setViewAllTable(section)}
/>

          ))}
        </div>
      </div>

      {/* Create Dialog */}
      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          dialogDetails={selectedRow}
          onSubmit={handleSubmit}
        />
      )}

      {/* Delete Dialog */}
      {dialogType === DIALOG_TYPES.DELETE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.DELETE}
          dialogDetails={{
            title: "Delete Confirmation",
            content: deleteMessage,
            rowData: selectedRow,
          }}
          onDelete={handleDeleteConfirm}
          type="setting"
        />
      )}

      {viewAllTable && (
        <CustomPopupForm
          isOpen={!!viewAllTable}
          handleClose={() => setViewAllTable(null)}
          dialogType="view-all"
          dialogDetails={{ content: viewAllTable, columns: servicesColumns }}
          onDelete={(row) => handleDelete(row, viewAllTable.label)}
        ></CustomPopupForm>
      )}
    </div>
  );
}
